/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useAuth } from "context/AuthContext";

export function SidebarLinks(props) {
  let location = useLocation();
  const { routes } = props;
  const { user, hasRole, hasPermission } = useAuth();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // Filter routes based on user role and permissions
  const filterRoutes = (routes) => {
    return routes.filter((route) => {
      if (route.hiddenInSidebar) {
      return false;
    }
      // Always show auth routes (or exclude them from sidebar)
      if (route.layout === "/auth") {
        return false; // Don't show auth routes in sidebar
      }

      // Check if route has role restrictions
      if (route.allowedRoles && route.allowedRoles.length > 0) {
        if (!hasRole(route.allowedRoles)) {
          return false;
        }
      }

      // Check if route has permission restrictions
      if (route.requiredPermissions && route.requiredPermissions.length > 0) {
        if (!hasPermission(route.requiredPermissions)) {
          return false;
        }
      }

      return true;
    });
  };

  const createLinks = (routes) => {
    const filteredRoutes = filterRoutes(routes);

    return filteredRoutes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "font-bold text-brand-500 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 flex ms-4 ${
                    activeRoute(route.path) === true
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute top-px h-9 w-1 rounded-lg bg-brand-500 end-0 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;